const UI = ({children}) => {
  return children;
};

export default UI;
